import { ApiService, WidgetModel } from '@kaiser-software/chassis-core';

export class WidgetService extends ApiService {

    public restEndpoint = 'widgets/:slug';

    public model = WidgetModel;

}



// WEBPACK FOOTER //
// ./apps/eyewatch/src/app/eyewatch/dashboards/services/widget.service.ts